import { useMemo } from 'react';
import { SINGLE_INSTALLATION_NAME_OPTIONS } from '../../../service/device/CommanderAirConnectAPI/CommanderAirConnectAPI.constants';
import useCurrentWorkspace from '../hooks/useCurrentWorkspace';
import { getDeviceNameOptions } from './getDeviceNameOptions';
import { useParams } from 'react-router-dom';

const SETTINGS_KEY = 'flexeserveUI.deviceNameOptions';

export const useDeviceNameOptions = (marketIdProp?: string): string[] => {
  const { marketId = marketIdProp } = useParams<{ marketId: string }>();
  const { data: currentWorkspace } = useCurrentWorkspace(marketId);

  return useMemo(
    () =>
      getDeviceNameOptions(
        currentWorkspace?.settings?.[SETTINGS_KEY],
        SINGLE_INSTALLATION_NAME_OPTIONS
      ),
    [currentWorkspace?.settings]
  );
};
